import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {useImportFromFileStore} from '../import-from-file-store'
import {DescriptionTable} from './description-table'

const templatePath = '/templates/files/import-file.csv'

export const Description = observer(() => {
  const [state] = useImportFromFileStore()
  const [lowerCaseColumns, setLowerCaseColumns] = useState<string[]>([])

  useEffect(() => {
    const columns = (state.columnTitles || []).map(column =>
      column.toLowerCase()
    )
    setLowerCaseColumns(columns)
  }, [state.columnTitles])

  const lang = Lang.msg.importFromFile

  return (
    <div className="mb-16 leading-main text-14 font-medium">
      {lang.newTextPart1}
      <br />
      <br />
      {lang.newTextPart2}
      <br />
      {lang.newTextPart3}&nbsp;
      <a href={templatePath} target={'_blank'} rel="noopener">
        {lang.templateImportFileLink}
      </a>
      <br />
      <br />
      {lang.newTextPart4}
      <br />
      {lang.newTextPart5}
      <br />
      {lang.newTextPart6}
      <br />
      {lang.newTextPart7}
      <br />
      {lang.newTextPart8}
      <br />
      <br />
      {lang.newTextPart9}
      <br />
      <br />
      <DescriptionTable fileColumnNames={lowerCaseColumns} />
      {lang.saveAndUpload}:
    </div>
  )
})
